export function toStringEnum(enumType, rawValue) {
    if (rawValue == null) {
        return undefined; // enum value is not found
    }
    return Object.values(enumType).find(function (enumValue) { return enumValue === rawValue; });
}
//# sourceMappingURL=toStringEnum.js.map